
/**
 * Allows exporting array data as a downloadable csv file for users.
 * @param {array} arrayHeader - The columns that will be displayed on the csv and corresponding object name
 * @param {array} fields      - The respective fields to take from each entry in arrayData
 * @param {array} arrayData   - Each entry being an object that contains the data
 * @param {string} delimiter  - Used to split the arrayData string into columns
 * @param {string} fileName   - Resulting filename (.csv is added automatically)
*/
const exportCSV = (arrayHeader, fields, arrayData, secDefData, delimiter, fileName) => {
    let header = arrayHeader.join(delimiter) + '\n';
    let csv = header;

    if(secDefData.length != 0){
        arrayData.forEach( function(obj, index) {
            let row = [];
            let isSymbolCusip = /^[0-9]{3}[a-zA-Z0-9]{2}[a-zA-Z0-9*@#]{3}[0-9]$/g.test(obj.symbol) ? true : false;
            let isLocalSymbolCusip = /^[0-9]{3}[a-zA-Z0-9]{2}[a-zA-Z0-9*@#]{3}[0-9]$/g.test(obj.localSymbol) ? true : false;
    
            fields.forEach( key => {
                if(obj.type === "BOND" || obj.type === "FUND"){
                    if(key === "symbol"){
                        if(isSymbolCusip === true || obj.symbol.length > 5 || obj.type === "BOND"){
                            row.push('"-"');
                        } else {
                            row.push('"'+ obj[key] + '"');
                        }
                    } else if(key === "localSymbol") {
                        if(isLocalSymbolCusip ===true || obj.localSymbol.length > 5 || obj.type === "BOND"){
                            row.push('"-"');
                        } else {
                            row.push('"'+ obj[key] + '"');
                        }
                    }else if(key === 'description' && obj.type === "BOND"){
                        const index = secDefData.findIndex(bond => bond.conid === obj.conid);
                        row.push('"'+ secDefData[index].fullName + '"');
                    } else if(key === "country" && obj.country.length === 0){
                        row.push('"-"');
                    } else {
                        row.push('"'+ obj[key] + '"');
                    }
                } else if(obj.type === "CRYPTO") {
                    if(key === "country" && obj.country.length === 0){
                        row.push('"-"');
                    } else if(key === "description" && obj.description.length === 0)  {
                        row.push('"' + obj.symbol + '"');
                    } else if(key === "currency" && obj.currency.length === 0)  {
                        if(obj.localSymbol.includes('.')){
                            row.push('"' + obj.localSymbol.split('.')[1] + '"');
                        }
                    } else {
                        row.push('"'+ obj[key] + '"');    
                    }
                } else if (obj.hasOwnProperty(key)) {
                    row.push('"'+ obj[key] + '"');
                }
            })
            
            csv += row.join(delimiter) + '\n';
        })
    } else {
        arrayData.forEach( obj => {
            let row = [];
            
            fields.forEach( key => {
                if (obj.hasOwnProperty(key)) {
                    if(key === 'id'){
                        row.push('"'+ obj[key] + '(' + obj.name + ')' + '"');
                    } else {
                        row.push('"'+ obj[key] + '"');
                    }
                }
            })

            csv += row.join(delimiter) + '\n';
        })
    }

    let csvData = new Blob([csv], { type: 'text/csv' });
    let csvUrl = URL.createObjectURL(csvData);

    let hiddenElement = document.createElement('a');

    hiddenElement.href = csvUrl;
    hiddenElement.target = '_blank';
    hiddenElement.download = fileName + '.csv';
    hiddenElement.click();
}

export { exportCSV };
